/** Teto da matrícula, o mesmo do servidor. */
export const TETO_MATRICULA = 20;

/** A matrícula como o servidor grava: sem espaço nas pontas e em maiúsculas. */
export const normalizarMatricula = (texto: string) => texto.trim().toUpperCase();

/**
 * A mesma conferência do servidor: a matrícula é um código (não mais o CPF) de letras, números,
 * ponto, traço e barra — cada local tem o seu formato —, começando por letra ou número, até 20
 * caracteres. Espaço no meio, sublinhado e acento continuam fora.
 */
export function matriculaValida(texto: string): boolean {
    return new RegExp(`^[A-Z0-9][A-Z0-9./-]{0,${TETO_MATRICULA - 1}}$`).test(normalizarMatricula(texto));
}

export const MENSAGEM_MATRICULA_INVALIDA = 'Matrícula inválida: use letras, números, ponto, traço ou barra, até 20.';

/** A matrícula aparece como foi gravada: não é CPF, então não ganha ponto nem traço. */
export function formatarMatricula(matricula: string): string {
    return matricula;
}
